import React from "react";
import ContentTab from "@/components/ContentTab";
import { useContentRefresh } from "@/context/ContentContext";
import { ModuleHeader } from "./AdminUI";

export default function PageContentModule() {
    const refresh = useContentRefresh();
    return (
        <div data-testid="admin-content-module">
            <ModuleHeader eyebrow="Copy & imagery" title="Page Content" subtitle="Headlines, text and images on the Home, Menu, Specials, About and Contact pages." />
            <ContentTab sections={["home", "menu_page", "specials_page", "about_page", "contact_page"]} onSaved={refresh} />
        </div>
    );
}
